import { type ExtensionPayment, type ReservationPaymentLocationState } from '@features/reservation/types';

const isExtensionPayment = (value: unknown): value is ExtensionPayment => {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<ExtensionPayment>;
  return (
    typeof candidate.reservationId === 'string' &&
    typeof candidate.reservationSpanId === 'string' &&
    candidate.newEndAt instanceof Date &&
    typeof candidate.price?.amount === 'number' &&
    typeof candidate.price?.currency === 'string'
  );
};

/**
 * Read the extension being paid for from `/reservation/payment`'s router state.
 * `undefined` means the page pays for the pending reservation instead. The state
 * survives a reload (history state), but not a copied URL.
 */
export function readExtensionPayment(locationState: unknown): ExtensionPayment | undefined {
  if (!locationState || typeof locationState !== 'object') return undefined;
  const { extensionPayment } = locationState as ReservationPaymentLocationState;
  return isExtensionPayment(extensionPayment) ? extensionPayment : undefined;
}
